
import React from 'react'
import { Link } from "react-router-dom";

// hard services1
import multi_skill_technician from '../images/services/hard_services1/multiskill-technician.png'
import plumber from '../images/services/hard_services1/plumber.png'
import technicians from '../images/services/hard_services1/technician.png'
import bms_operator from '../images/services/hard_services1/BMS-operator.png'
import gym_instruction from '../images/services/hard_services1/gym-instruction.png'

// soft services1
import house_keeping from '../images/services/soft_services1/housekeeping.png'
import front_office_managment from '../images/services/soft_services1/reception.png'
import office_managment from '../images/services/soft_services1/office-management.png'
import office_boy from '../images/services/soft_services1/office-boy.png'
import pantry_service from '../images/services/soft_services1/pantry.png'
import office_admin from '../images/services/soft_services1/admin.png'
import gardening from '../images/services/soft_services1/gardening.png'
import swimming_pool from '../images/services/soft_services1/swimming_pool.png'

//security services
import security_guard from '../images/services/security_services/policeman.png'
import security_supervisor from '../images/services/security_services/police.png'
import escort_guard from '../images/services/security_services/securityguard.png'
import security_officer from '../images/services/security_services/policeman1.png'
import parking_management from '../images/services/security_services/parking-management.png'


function Services({params}) {

  const hard_services = [
    {   
        id:1,
        name:'Multi Skill Technician',
        img:multi_skill_technician
    },
    {   
        id:2,
        name:'Plumber',
        img:plumber
    },
    {   
        id:3,
        name:'Technicians',
        img:technicians
    },
    {   
        id:4,
        name:'BMS Operators',
        img:bms_operator
    },
    {   
        id:5,
        name:'Gym Instruction',
        img:gym_instruction
    },
    
  ]

  const soft_services = [
    {   
        id:1,
        name:'Housekeeping services',
        img:house_keeping
    },
    {   
        id:2,
        name:'Front Office Management',
        img:front_office_managment
    },
    {   
        id:3,
        name:'Office Management',
        img:office_managment
    },
    {   
        id:4,
        name:'Runner Boy',
        img:security_guard
    },
    {   
        id:5,
        name:'Office Boy',
        img:office_boy
    },
    {   
        id:6,
        name:'Pantry Services',
        img:pantry_service
    },
    {   
        id:7,
        name:'Office Admin',
        img:office_admin
    },
    {   
        id:8,
        name:'Gardner',
        img:gardening
    },
    {   
        id:9,
        name:'Swimming Pool Maintenance',
        img:swimming_pool
    },
   
  ]
  
  const fumigation_services = [
    {   
        id:1,
        name:'Security Guard',
        img:security_guard
    },
    {   
        id:2,
        name:'Security Supervisor',
        img:security_supervisor
    },
    {   
        id:3,
        name:'Escort Guard',
        img:escort_guard
    },
    {   
        id:4,
        name:'Security Officer',
        img:security_officer
    },
    {   
        id:5,
        name:'Parking Management',
        img:parking_management
    },
  ]

//   const { servicesId } = router.query

  return (
    <div className='w-full h-full overflow-hidden'>
          <div className='min-h-[180px] bg-black  relative md:min-h-[240px] 2xl:min-h-[500px] bg-cover md:bg-contain bg-no-repeat w-full bg-right-top bg-services_bg'>
          <div data-aos="fade-left" className='absolute top-[5%] md:top-[15%]  w-[75%] md:w-[35%]' >
            <div className='border-l w-full border-l-4  border-l-[#4190ac] ml-[6%] pl-[1.5%] absolute top-[15%]'>
                <h6 className='text-[19px] 2xl:text-[22px] font_thicker md:text-[21px] text-[#fff] font-[800]  '>Our Services</h6>
                <h6 className='text-[18px] 2xl:text-[21px] md:text-[21px] text-[#fff] font-[800]  '>{params?.servicesId === 'security_services' && 'Security Services'} {params?.servicesId === 'hard_services' && 'Hard Services'} {params?.servicesId === 'soft_services' && 'Soft Services'}</h6>
                <h6 className='text-[13px] 2xl:text-[16px]  md:text-[14px] text-[#fff]'>Comprehensive facility management services tailored to meet your business needs.</h6>
            </div>
          </div>
        </div>
        <div className='w-[80%] mx-auto py-20'>
           {/* Detail Page {params?.servicesId} */}


           {/* security services  */}

           {/* {params?.servicesId  === "security_services" && */}
           <>

            <h6 className='font_thicker text-[20px] 2xl:text-[23px] mb-4'>Reliable Security Services</h6>
            <h6 className='text-[14.5px] 2xl:text-[17.5px] font_normal'>"Our trained security personnel safeguard your premises with vigilance, discipline, and 
            professionalism.”</h6>


            <div className='grid grid-cols-2 gap-2 mt-10 md:grid-cols-6'>
               {fumigation_services?.map((s,i)=>(
                <div key={i} data-aos="fade-up" className='flex flex-col items-center justify-center w-full'>
                   <img alt={s?.img} className={`opacity-80 object-contain  h-[65px] flex items-center `} src={s?.img} /> 
                   <h6 className='mt-2 text-[13px] 2xl:text-[16px] w-[90%] text-center mb-4 font_thicker'>{s?.name}</h6>
                </div>   
               ))}
            </div> 


            <h6 className='font_thicker text-[15px] 2xl:text-[18px] mt-10'>We provide :</h6>

            <ul className='mt-5 ml-6 list-disc'>
  <li className='text-[14px] 2xl:text-[17px] mt-1'>Proficient and vetted manpower</li>
  <li className='text-[14px] 2xl:text-[17px] mt-1'>Bodyguards / Gunman (with License)</li>
  <li className='text-[14px] 2xl:text-[17px] mt-1'>Enhanced safety for women with escort guards</li>
  <li className='text-[14px] 2xl:text-[17px] mt-1'>Safety / Security audit</li>
  <li className='text-[14px] 2xl:text-[17px] mt-1'>Round the clock close monitoring</li>
  <li className='text-[14px] 2xl:text-[17px] mt-1'>Equipped to handle fire and health emergencies</li>
  <li className='text-[14px] 2xl:text-[17px] mt-1'>Good communication skills and ability in managing front office</li>
  <li className='text-[14px] 2xl:text-[17px] mt-1'>Access Control / CCTV Monitoring</li>
  <li className='text-[14px] 2xl:text-[17px] mt-1'>Security Screening / Car Parking</li>
  <li className='text-[14px] 2xl:text-[17px] mt-1'>Guards / Supervisor / Mobile Patrol</li>
  <li className='text-[14px] 2xl:text-[17px] mt-1'>24/7 Emergency Services</li>
  <li className='text-[14px] 2xl:text-[17px] mt-1'>Managing Building Management System Rooms in Tech Equipped Buildings</li>
</ul>
           </>
           {/* } */}

           {/* {params?.servicesId  === "hard_services" && */}
           <>

            <h6 className='font_thicker text-[20px] 2xl:text-[23px] mt-10 my-4'>Efficient Maintenance Services</h6>
            <h6 className='text-[14.5px] 2xl:text-[17.5px] font_normal'>We provide technical support and maintenance solutions to ensure uninterrupted operations 
            and reduced downtime.”</h6>
            <h6 className='text-gray-500 font_thicker text-[18px] 2xl:text-[21px] opacity-70 mt-5'>Our Services include:</h6>

            <div className='grid grid-cols-2 gap-2 mt-10 md:grid-cols-6'>
               {hard_services?.map((s,i)=>(
                <div key={i} data-aos="fade-up" className='flex flex-col items-center justify-center w-full'>
                   <img alt={s?.img} className={`opacity-80 object-contain  h-[65px] flex items-center `} src={s?.img} /> 
                   <h6 className='mt-2 text-[13px] 2xl:text-[16px] w-[90%] text-center mb-4 font_thicker'>{s?.name}</h6>
                </div>   
               ))}
            </div> 
           </>
           {/* } */}

           {/* {params?.servicesId  === "soft_services" && */}
           <>
            <h6 className='font_thicker text-[20px] 2xl:text-[23px] mt-10 my-4'>Professional Housekeeping Services</h6>
            <h6 className='text-[14.5px] 2xl:text-[17.5px] font_normal'>"We ensure clean, hygienic, and well-maintained environments that enhance employee productivity and create a positive impression.”</h6>
            <h6 className='text-gray-500 font_thicker text-[18px] 2xl:text-[21px] opacity-70 mt-5'>Our Services include:</h6>

            <div className='grid grid-cols-2 gap-2 mt-10 md:grid-cols-6'>
               {soft_services?.map((s,i)=>(
                <div key={i} data-aos="fade-up" className='flex flex-col items-center justify-center w-full'>
                   <img alt={s?.img} className={`opacity-80 object-contain  h-[65px] flex items-center `} src={s?.img} /> 
                   <h6 className='mt-2 text-[13px] 2xl:text-[16px] w-[90%] text-center mb-4 font_thicker'>{s?.name}</h6>
                </div>   
               ))}
            </div> 

            {/* CTA Section */}
<div className="flex flex-col items-center justify-center py-16 mt-12 text-center border-t border-gray-200">
  <h6 className="font_thicker text-[22px] 2xl:text-[28px] text-[#027d9b]">
    Looking for a Reliable Facility Management Partner?
  </h6>

  <p className="mt-3 text-[14px] 2xl:text-[17px] text-gray-600 max-w-2xl">
    Let us help you create a cleaner, safer, and more efficient workplace with our
    comprehensive facility management solutions.
  </p>

  <Link
  to="/Contact"
  className="px-8 py-3 mt-6 text-white transition-all duration-300 rounded-full bg-[#027d9b] hover:bg-[#026b84] hover:scale-105"
>
  Get In Touch
</Link>
</div>
           </>
           {/* } */}

        </div>
    </div>
  )
}

export default Services